import React from 'react'
import NoWorkOrdersNotice from './NoWorkOrdersNotice'
import Show from '@components/Show'
import WorkOrderCard from './WorkOrderCard'

interface FilteredWorkOrdersProps {
  goToWorkOrder: (workOrderNumber: number) => void
  workOrders: WorkOrder[]
  statusFilter?: WorkOrderStatusName
}

const FilteredWorkOrders = (props: FilteredWorkOrdersProps) => {
  const { goToWorkOrder, statusFilter, workOrders } = props

  if (statusFilter === null || statusFilter === undefined) {
    // Status filter is "All"
    // We want to sort work orders so that active ones are shown last
    const activeWorkOrders: WorkOrder[] = []
    const otherWorkOrders: WorkOrder[] = []
    workOrders?.forEach((workOrder) => {
      if (workOrder.status.name === 'Active') activeWorkOrders.push(workOrder)
      else otherWorkOrders.push(workOrder)
    })
    const sortedWorkOrders = [...otherWorkOrders, ...activeWorkOrders]

    return (
      <>
        { sortedWorkOrders?.map((workOrder, index) => (
          <WorkOrderCard
            key={index}
            workOrder={workOrder}
            onPress={ () => goToWorkOrder(workOrder.workOrderNumber) }
          />
        ))}
      </>
    )
  }

  const filteredWorkOrders = workOrders?.filter((workOrder: WorkOrder) => (
    workOrder.status.name === statusFilter
  ))

  return (
    <>
      <Show when={!filteredWorkOrders?.length}>
        <NoWorkOrdersNotice />
      </Show>
      { filteredWorkOrders?.map((workOrder, index) => (
          <WorkOrderCard
            key={index}
            workOrder={workOrder}
            onPress={ () => goToWorkOrder(workOrder.workOrderNumber) }
          />
      ))}
    </>
  )
}

export default FilteredWorkOrders
